var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formattedContents.length
    ? _c("div", { staticClass: "table" }, [
        _c("div", { staticClass: "table-header" }, [
          _c(
            "div",
            { staticClass: "tr-box row" },
            [
              _vm._l(_vm.formattedHeaders, function (header) {
                return _c(
                  "div",
                  { key: header.label, staticClass: "th-box columns" },
                  [_vm._v("\n        " + _vm._s(header.text) + "\n      ")]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "th-box columns small-1" }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-content" },
          _vm._l(_vm.formattedContents, function (row, index) {
            return _c(
              "div",
              { key: index, staticClass: "tr-box row" },
              [
                _vm._l(row, function (column) {
                  return _c(
                    "div",
                    { key: column.text, staticClass: "td-box columns" },
                    [_c("span", [_vm._v(_vm._s(column.text))])]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "td-box columns small-1" }, [
                  _vm.removable
                    ? _c("span", {
                        staticClass: "fa fa-times fa-lg cursor-pointer",
                        on: {
                          click: function ($event) {
                            return _vm.removeRow(index)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ],
              2
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }